import formatHour from '../date/formatHour';
import 'custom-event-polyfill';
export default class TimeSlider {
  constructor(target) {
    if (!(target instanceof HTMLElement)) return;

    this.target = target;
    this.min = Number(this.target.dataset.min);
    this.max = Number(this.target.dataset.max);
    this.handles = [...this.target.querySelectorAll('.handle')];
    this.startPos = 0;
    this.activeHandle;

    this.handles.forEach((handle) => {
      handle.addEventListener('mousedown', this.startMove.bind(this));
      handle.addEventListener('touchstart', this.startMoveTouch.bind(this));
    });

    window.addEventListener('mouseup', this.stopMove.bind(this));
    window.addEventListener('touchend', this.stopMove.bind(this));
    window.addEventListener('touchcancel', this.stopMove.bind(this));
    window.addEventListener('touchleave', this.stopMove.bind(this));

    const rangeRect = this.target.getBoundingClientRect();
    const handleRect = this.handles[0].getBoundingClientRect();
    this.unitWidth = rangeRect.width / (this.max - this.min);
    this.target.style.setProperty('--x-1', 0 + 'px');
    this.target.style.setProperty('--x-2', rangeRect.width - handleRect.width + 'px');
    this.setHandleValue(this.handles[0], this.min);
    this.setHandleValue(this.handles[1], this.max);
  }

  setHandleValue(handle, value) {
    if (value !== handle.dataset.value) {
      handle.dataset.value = value;
      handle.dataset.label = formatHour(value);
      let property = 'to';
      if (handle.classList.contains('left')) {
        property = 'from';
      }
      document.dispatchEvent(new CustomEvent('ts-change', {detail: {property, value}}));
    }
  }
  startMoveTouch(e) {
    const handleRect = e.target.getBoundingClientRect();
    this.startPos = e.touches[0].clientX - handleRect.x;
    this.activeHandle = e.target;
    this.moveTouchListener = this.moveTouch.bind(this);
    window.addEventListener('touchmove', this.moveTouchListener);
  }

  startMove(e) {
    this.startPos = e.offsetX;
    this.activeHandle = e.target;
    this.moveListener = this.move.bind(this);
    window.addEventListener('mousemove', this.moveListener);
  }

  moveTouch(e) {
    this.move({ clientX: e.touches[0].clientX });
  }

  move(e) {
    const isLeft = this.activeHandle.classList.contains('left');
    const property = isLeft ? '--x-1' : '--x-2';
    const parentRect = this.target.getBoundingClientRect();
    const handleRect = this.activeHandle.getBoundingClientRect();
    let gap = this.unitWidth;
    let newX = e.clientX - parentRect.x - this.startPos;

    if (isLeft) {
      const otherX = parseInt(this.target.style.getPropertyValue('--x-2'));
      newX = Math.min(newX, otherX - handleRect.width - gap);
      newX = Math.max(newX, 0);
    } else {
      const otherX = parseInt(this.target.style.getPropertyValue('--x-1'));
      newX = Math.max(newX, otherX + handleRect.width + gap);
      newX = Math.min(newX, parentRect.width - handleRect.width);
      gap = -gap;
    }
    const value = this.calcHandleValue(
      newX / (parentRect.width - handleRect.width - gap),
      this.activeHandle.dataset
    );
    this.setHandleValue(this.activeHandle, value);
    this.target.style.setProperty(property, newX + 'px');
  }

  calcHandleValue(percentage, { min, max }) {
    return Math.round(percentage * (max - min) + Number(min));
  }

  stopMove() {
    window.removeEventListener('mousemove', this.moveListener);
    window.removeEventListener('touchmove', this.moveTouchListener);
  }
}

